import React from "react";
import { useIdTokenSubscriber } from "../../libs/auth/use-id-token-subscriber";

const IdTokenSubscriber: React.FC = () => {
  useIdTokenSubscriber();
  return null;
};

export default IdTokenSubscriber;
